export default "__VITE_ASSET__Dre78IdR__"